// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-app>
    <v-navigation-drawer app clipped persistent v-model="showDrawer">
      <v-list style="padding: 0px;">
        <v-list-tile style="background-color: rgba(0,0,0,0.07);" >
          <v-list-tile-content>
          </v-list-tile-content>
          <v-list-tile-action v-if="isMobile">
            <v-menu offset-y>
              <v-btn icon flat slot="activator"><v-icon x-large>account_circle</v-icon></v-btn>
              <v-list>
                <v-list-tile :to="{name: 'userMe'}">
                  <v-list-tile-title>Profile</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="logout">
                  <v-list-tile-title>Logout</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-list-tile-action>
        </v-list-tile>

        <template v-for="(item, i) in menu">
          <template v-if="item.items">
            <v-list-group :key="i">
              <v-list-tile slot="activator">
                <v-list-tile-action>
                  <v-icon>{{ item.action }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile v-for="subItem in item.items" :key="subItem.title" :to="{name: subItem.route}">
                <v-list-tile-action> </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-icon>{{ subItem.action }}</v-icon>
                </v-list-tile-action>
              </v-list-tile>
            </v-list-group>
          </template>
          <template v-else>
            <v-list-tile :to="{name: item.route}" :key="i">
              <v-list-tile-action>
                <v-icon>{{ item.action }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </template>
        <v-list-tile style="background-color: rgba(0,0,0,0.07);">
          <v-list-tile-action>
            <v-icon></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>v{{ version }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar v-if="showToolbar" app clipped-left clipped-right fixed>
      <v-toolbar-side-icon @click.stop="showDrawer = !showDrawer"></v-toolbar-side-icon>
      <v-toolbar-title v-if="(this.$vuetify.breakpoint.xsOnly && !showSearch) || this.$vuetify.breakpoint.smAndUp" class="mx-3">Key Assure</v-toolbar-title>
      <v-text-field v-if="showSearch"
        solo
        flat
        prepend-icon="search"
        append-icon="clear"
        @click:append="(event) => clearSearch()"
        v-model="searchBarText">
      </v-text-field>
      <v-spacer v-if="!showSearch"></v-spacer>

      <v-menu offset-y v-if="!isMobile">
        <v-btn icon flat slot="activator"><v-icon x-large>account_circle</v-icon></v-btn>
        <v-list>
          <v-list-tile :to="{name: 'userMe'}">
            <v-list-tile-title>Profile</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="logout">
            <v-list-tile-title>Logout</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-content>
      <router-view :searchBarText="searchBarText"></router-view>
    </v-content>
    <v-footer style="height: 82px; background-color: #fafafa;">
    </v-footer>

  </v-app>
</template>

<script>
import { removeCookie } from 'tiny-cookie'

import { mapActions, mapGetters, mapMutations } from 'vuex'
import {AXIOSAPI} from '@/api/api'
import {PERMISSIONS} from 'vue-common/components/constants'
import {checkPermission} from 'vue-common/components/user'

import {version} from '../../package.json'

export default {
  name: 'App',
  data () {
    return {
      forms: [],
      showDrawer: true,
      showToolbar: true,
      sites: [],
      version: version,
      searchBarText: '',
      searchBarVisible: false
    }
  },

  computed: {
    ...mapGetters([
      'accessRules',
      'filters',
      'selectedSite'
    ]),

    adminMenu: function () {
      var adminMenuList = []

      if (checkPermission(this.accessRules, 'apikeys', PERMISSIONS.CREATE)) {
        adminMenuList.push({
          title: 'API Keys',
          route: 'apikeys',
          action: 'vpn_key'
        })
      }

      if (checkPermission(this.accessRules, 'emailtemplates', PERMISSIONS.MODIFY)) {
        adminMenuList.push({
          title: 'Email Template',
          route: 'emailTemplateEdit',
          action: 'mail'
        })
      }

      if (checkPermission(this.accessRules, 'settings', PERMISSIONS.MODIFY)) {
        adminMenuList.push({
          title: 'Settings',
          route: 'settingsEdit',
          action: 'settings'
        })
      }

      if (checkPermission(this.accessRules, 'users', PERMISSIONS.CREATE)) {
        adminMenuList.push({
          title: 'Users',
          route: 'users',
          action: 'group'
        })
      }
      return {
        action: 'build',
        title: 'Admin',
        items: adminMenuList
      }
    },

    configurationMenu: function () {
      var configurationMenuList = []

      if (checkPermission(this.accessRules, 'organizations', PERMISSIONS.MODIFY)) {
        configurationMenuList.push({
          title: 'Organizations',
          route: 'organizations',
          action: 'filter_list'
        })
      }

      if (checkPermission(this.accessRules, 'owners', PERMISSIONS.CREATE)) {
        configurationMenuList.push({
          title: 'Owners',
          route: 'owners',
          action: 'filter_list'
        })
      }

      if (checkPermission(this.accessRules, 'organizations', PERMISSIONS.MODIFY)) {
        configurationMenuList.push({
          title: 'Photo Settings',
          route: 'settingsPhotoEdit',
          action: 'settings'
        })
      }

      if (checkPermission(this.accessRules, 'roles', PERMISSIONS.MODIFY)) {
        configurationMenuList.push({
          title: 'Roles',
          route: 'roles',
          action: 'supervisor_account'
        })
      }
      if (checkPermission(this.accessRules, 'rules', PERMISSIONS.MODIFY)) {
        configurationMenuList.push({
          title: 'Rules',
          route: 'rules',
          action: 'filter_list'
        })
      }

      return {
        action: 'settings',
        title: 'Configuration',
        items: configurationMenuList
      }
    },

    isMobile: function () {
      return this.$vuetify.breakpoint.xsOnly
    },

    menu: function () {
      var menu = []

      menu.push({
        action: 'home',
        title: 'Home',
        route: 'home'
      })

      if (checkPermission(this.accessRules, 'customers', PERMISSIONS.MODIFY)) {
        menu.push({
          title: 'Customers',
          route: 'customers',
          action: 'folder_shared'
        })
      }

      if (checkPermission(this.accessRules, 'items', PERMISSIONS.READ)) {
        menu.push({
          title: 'Items',
          route: 'items',
          action: 'label'
        })
      }

      if (checkPermission(this.accessRules, 'items', PERMISSIONS.READ)) {
        menu.push({
          title: 'Licenses',
          route: 'licenses',
          action: 'enhanced_encryption'
        })
      }

      if (this.adminMenu.items.length > 0) {
        menu.push(this.adminMenu)
      }

      if (this.configurationMenu.items.length > 0) {
        menu.push(this.configurationMenu)
      }

      return menu
    },

    showSearch: function () {
      if (this.$route.name === 'customers') {
        return true
      }

      return false
    }
  },

  created () {
    // Hide the toolbar when rendering for print, otherwise show it.
    var mediaQueryList = window.matchMedia('print')
    mediaQueryList.addListener(mql => {
      if (mql.matches) {
        this.showDrawer = false
        this.showToolbar = false
      } else {
        this.showDrawer = true
        this.showToolbar = true
      }
    })

    // window.Bus.$on('setSearchText', payload => {
    //   this.searchBarText = payload.searchText
    // })

    this.getUserData()
    // this.getSites().then(() => this.updatePath())
  },

  // beforeDestroy () {
  //   window.Bus.$off('setSearchText')
  // },

  watch: {
    filters: function () {
      this.updatePath()
    },

    '$route.name': function () {
      this.updatePath()
      this.searchBarVisible = false
      this.searchBarText = ''
    }

    // accessRules: function () {
    //   this.getSites()
    // }
  },

  methods: {
    ...mapActions([
      'getUserData'
    ]),

    ...mapMutations([
      'setSite'
    ]),

    checkPermission: function (item) {
      return checkPermission(this.accessRules, item, PERMISSIONS.MODIFY)
    },

    updatePath: function () {
      if (this.selectedSite && this.selectedSite._id) {
        var query = Object.assign({}, this.$route.query)
        query.site = this.selectedSite._id
        this.$router.replace({
          name: this.$route.name,
          query: query
        })
      }
    },

    clearSearch: function () {
      this.searchBarText = ''
    },

    logout: function () {
      AXIOSAPI.post('auth/logout').then(response => {
        removeCookie('jwt_token')
      }).catch(e => {
        console.error(e)
        removeCookie('jwt_token')
      })
      this.$router.push({name: 'login'})
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
a {
    text-decoration: none;
}

.container {
  padding: 8px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue